import { gsap } from 'gsap/all'
import { store } from '../../src/js/core/store.js'

export const initDigIn = () => {
  const section = document.querySelector('.js-dig-in')
  if (!section) { return false }

  new DigIn(section)
}

class DigIn {
  constructor (section) {
    this.section = section
    this.buttons = [...this.section.querySelectorAll('.js-scrollto')]
    this.blocks = [...this.section.querySelectorAll('.js-block')]
    this.tiles = [...this.section.querySelectorAll('.js-dig-tile')]
    this.init()
  }

  bindButtons () {
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        window.scrollTo({
          top: this.blocks[index].getBoundingClientRect().top + window.scrollY,
          left: 0,
          behavior: 'smooth'
        })
      })
    })
  }

  init () {
    this.bindButtons()

    this.tiles.forEach(tile => {
      new Tile(tile)
    })
  }
}

class Tile {
  constructor (tile) {
    this.tile = {
      element: tile,
      image: tile.querySelector('img'),
      first: tile.querySelector('.js-first'),
      second: tile.querySelector('.js-second')
    }

    this.init()
  }

  enter = () => {
    if (this.tile.image) {
      gsap.to(this.tile.image, 0.5, {
        scale: 1.05,
        ease: 'power4.out'
      })
    }

    gsap.to(this.tile.first, 0.5, {
      x: 0,
      opacity: 1,
      ease: 'power4.out'
    })

    gsap.to(this.tile.second, 0.5, {
      x: 15,
      opacity: 0,
      ease: 'power4.out'
    })
  }

  leave = () => {
    if (this.tile.image) {
      gsap.to(this.tile.image, 0.5, {
        scale: 1,
        ease: 'power4.out'
      })
    }

    gsap.set(this.tile.first, {
      x: -15,
      opacity: 0
    })

    gsap.set(this.tile.second, {
      x: 0,
      opacity: 1
    })
  }

  init () {
    if (!store.isDevice) {
      this.tile.element.addEventListener('mouseenter', this.enter)
      this.tile.element.addEventListener('mouseleave', this.leave)
    }
  }
}
